<template>
    <v-text-field 
        :value="value" 
        @change="$emit('change', $event)"
        :label="schema.label" 
        :hide-details="false" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder || ' '"
        outlined dense
    />
</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: String,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// TextControl.vue?71315a5d